/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Ad_Jobs_FoundInputs */

const en_no_ad_jobs_found = /** @type {(inputs: No_Ad_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No AD generation jobs found for the selected period.`)
};

const fr_no_ad_jobs_found = /** @type {(inputs: No_Ad_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune tâche de génération de publicités n'a été trouvée pour la période sélectionnée.`)
};

const de_no_ad_jobs_found = /** @type {(inputs: No_Ad_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für den ausgewählten Zeitraum wurden keine AD-Generierungsaufträge gefunden.`)
};

const it_no_ad_jobs_found = /** @type {(inputs: No_Ad_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun processo di generazione di annunci pubblicitari trovato per il periodo selezionato.`)
};

const ru_no_ad_jobs_found = /** @type {(inputs: No_Ad_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За выбранный период не найдено заданий по генерации AD.`)
};

const es_no_ad_jobs_found = /** @type {(inputs: No_Ad_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron trabajos de generación de AD para el período seleccionado.`)
};

const zh_cn2_no_ad_jobs_found = /** @type {(inputs: No_Ad_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在所选时间段内未找到 AD 生成作业。`)
};

const ja_no_ad_jobs_found = /** @type {(inputs: No_Ad_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択した期間に該当するAD生成ジョブは見つかりませんでした。`)
};

const hi_no_ad_jobs_found = /** @type {(inputs: No_Ad_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित अवधि के लिए कोई विज्ञापन सृजन कार्य नहीं मिला।`)
};

const pt_pt2_no_ad_jobs_found = /** @type {(inputs: No_Ad_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foram encontradas tarefas de geração de anúncios de emprego para o período selecionado.`)
};

/**
* | output |
* | --- |
* | "No AD generation jobs found for the selected period." |
*
* @param {No_Ad_Jobs_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_ad_jobs_found = /** @type {((inputs?: No_Ad_Jobs_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Ad_Jobs_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_no_ad_jobs_found(inputs)
	if (locale === "de") return de_no_ad_jobs_found(inputs)
	if (locale === "it") return it_no_ad_jobs_found(inputs)
	if (locale === "ru") return ru_no_ad_jobs_found(inputs)
	if (locale === "es") return es_no_ad_jobs_found(inputs)
	if (locale === "zh-CN") return zh_cn2_no_ad_jobs_found(inputs)
	if (locale === "ja") return ja_no_ad_jobs_found(inputs)
	if (locale === "hi") return hi_no_ad_jobs_found(inputs)
	if (locale === "pt-PT") return pt_pt2_no_ad_jobs_found(inputs)
	return en_no_ad_jobs_found(inputs)
});